<template>
    <div :style="{ 'height': heightStyle }" class="row m-0 blog-preview-badge" @click="() => activateBlogsNameMenuItem(id)">
        <div :style="{ 'height': imageContainerHeight }" class="col-12 col-lg-4 col-xl-4">
            <div class="image-container">
                <img 
                    :src="image" 
                    :alt="imageDescription" 
                    class="cover" 
                />
            </div>
        </div>
        <div :style="{ 'height': infoContainerHeight }" class="col-12 col-lg-8 col-xl-8 pl-lg-0 pl-xl-0" :class="paddingTopClass">
            <div class="info-area">
                <div style="height: 35%;">
                    <h3 class="limit-lines-2">{{ title }}</h3>
                </div>
                <div :style="{ 'height': captionHeight }" class="caption limit-lines-4">
                    {{ caption }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "blog-preview-badge",
    props: [
        "id",
        "image",
        "imageDescription",
        "title",
        "caption",
        "likes",
        "shares",
        "date",
        "blogPage",
        "query",
        "isRecentBlogs"
    ],
    computed: {
        isMobile() {
            return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
        },
        isInTabletRange() {
            const screenWidth = this.$store.state.screenWidth;
            return screenWidth > 940 && screenWidth < 992;
        },
        heightStyle() {
            return this.isInTabletRange || this.isMobile ? '360px' : '180px';
        },
        imageContainerHeight() {
            return this.isInTabletRange || this.isMobile ? '45%' : '100%';
        },
        infoContainerHeight() {
            return this.isInTabletRange || this.isMobile ? '55%' : '100%';
        },
        captionHeight() {
            return this.isInTabletRange || this.isMobile ? '55%' : '65%';
        },
        paddingTopClass() {
            return this.isMobile ? 'pt-0' : 'pt-3';
        }
    },
    methods: {
        activateBlogsNameMenuItem(blogId) {
            let blogDetailUrl = `/blogdetail?isRecentBlogs=${this.isRecentBlogs}&id=${blogId}`;
            if(this.blogPage) {
                blogDetailUrl = `${blogDetailUrl}&blogPage=${this.blogPage}`;
            }
            if(this.query && this.query.length !== 0) {
                blogDetailUrl = `${blogDetailUrl}&query=${this.query}`;
            }
            this.$router.push(blogDetailUrl);
        },
    },
}
</script>

<style>
.blog-preview-badge {
    border: 1px solid #272727;
    border-radius: 5px;
    cursor: pointer;
    color: #272727;
}
.blog-preview-badge:hover {
    border-width: 2px;
    border-color: #424EC4;
    color: #424EC4;
}

.image-container {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #272727;
}
.cover {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.info-area {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.info-area h3 {
    margin: 0;
    min-height: 40px;
    max-height: 50px;
    font-size: 18px;
    line-height: 1.5rem;
    margin-bottom: 15px;
}

.info-area .caption {
    margin: 0 !important;
    font-size: 15px;
    line-height: 1.5rem;
    height: 60%;
}

.info-area .date {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.info-badge {
    height: 33px;
    width: 70px;
    background-color: #c7c5c5;
    display: flex;
    justify-content: center;
    align-items: center;
}

.info-badge > span {
    font-size: 19px;
}

.bottom-buttons {
    display: flex;
    margin-top: 5px;
    margin-bottom: 10px;
}

</style>